import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import PageHeader from "../../components/PageHeader";
import { formBg } from "../../asset";
import FormApis from "../../api/formApis";
import { useBranchCode } from "../../util/hooks/useBranch";

export default function CreateForm() {
  const navigate = useNavigate();
  const { formId: paramFormId } = useParams();
  const { state } = useLocation();
  const formIdFromState = state?.formId;
  const initialFormName = state?.formName || "";
  const formId = formIdFromState || paramFormId;
  const isEdit = !!formId;
  const [formName, setFormName] = useState(initialFormName);

  const branchCode = useBranchCode();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formName.trim()) return;

    try {
      if (isEdit) {
        const res = await FormApis.updateForm(formId, formName.trim());
        if (res?.status === 1) {
          navigate(`/form/create-form/add/${res.data.formId}`, {
            state: { formName, formSeqId: res.data.formSeqId },
          });
        }
      } else {
        const res = await FormApis.createForm(
          { formName: formName.trim() },
          branchCode,
        );
        if (res?.status === 1) {
          navigate(`/form/create-form/add/${res.data.formId}`, {
            state: { formName, formSeqId: res.data.formSeqId },
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <PageHeader title={formName || "CREATE NEW FORM"} showBack />

      <div
        className="bg-white rounded-lg py-10 md:py-20 px-4 md:px-10 flex flex-col gap-16 md:gap-24 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${formBg})` }}
      >
        <div className="flex flex-col gap-2 text-center">
          <h3 className="text-xs md:text-sm font-semibold text-neutral-300">
            Form Setup & Configuration
          </h3>
          <p className="text-lg md:text-3xl font-semibold text-primary-600">
            {isEdit
              ? "Update form name"
              : "Create interactive forms with minimal effort"}
          </p>
        </div>

        <form
          className="w-full max-w-2xl mx-auto flex flex-col gap-6 md:gap-8"
          onSubmit={handleSubmit}
        >
          <CustomInput
            name="formName"
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
            placeholder="Enter the name of the form"
            label="Form Name"
          />

          <div className="flex justify-end">
            <CustomButton color="bg-primary-600" text="Next" type="submit" />
          </div>
        </form>
      </div>
    </div>
  );
}
